import React, { Component } from 'react';
import { API } from "aws-amplify";
import './Thread.css';


export default class ReplyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputFrom: '',
      inputTo: '',
      inputCc: '',
      inputSubject: '',
      inputBody: '',
    };
  }

  componentDidMount() {
    this.setState({
      inputFrom: "me",
      inputTo: this.props.threadItem._source.eventFrom,
      inputCc: '',
      inputSubject: this.props.threadItem._source.eventSubject,
      inputBody: '',
    })
  }

  handleInputBody = event => {
    this.setState({ searchInput: event.target.value });
  }

  sendMessage(message) {
    return API.post("contacts", `/send/`, { body: { message }});
  }

  handleClickSend = async () => {
    const message = {
      userEmailAddress: '',
      from: this.state.inputFrom,
      to: 'todd@exactify.com',
      // cc,
      // bcc,
      subject: this.state.inputSubject,
      body: this.state.inputBody,
      // threadId,
      // replytoMessageId,
    };
    const sendResults = await this.sendMessage(message);
    console.log('sendResults', sendResults);
  }

  render() {
    return (
      <div className="Person">
        <div align="right">EMAIL REPLY</div>
        <div>From: {this.state.inputFrom}</div>
        <div>To: {this.state.inputTo}</div>
        <div>Subject: {this.state.inputSubject}</div>
        <div><textarea style={{"width":"100%"}} onChange={this.handleInputBody} value={this.state.inputBodu} /></div>
        <div align="right">
          <button onClick={this.handleClickSend}>Send</button>
          <button onClick={this.props.clickedCancel}>Cancel</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Timeline/ReplyForm.js